import { createContext } from 'react';
import type { ChatSessionsContextValue } from '../../../types/chatSessionsContext';

export const ChatSessionsContext =
  createContext<ChatSessionsContextValue | null>(null);
